import type { PortfolioVideo } from '../types/portfolio';
import { portfolioVideos } from '../data/portfolioVideos';
import { replaceCommentSectionPortfolioVideos } from '../data/portfolioVideoReplacements';

const portfolioTagOrder = [
  'Documentary',
  'Commentary',
  'Podcast',
  'Short Film',
  'Highlights',
];

const tagAliases: Record<string, string> = {
  'Interview': 'Podcast',
  'Reaction': 'Commentary',
  'Explainer': 'Commentary',
  'Mini Documentary': 'Documentary',
  'Ben Shapiro': 'Commentary',
  'Brett Cooper': 'Commentary',
  'Jordan B Peterson': 'Podcast',
  'Matt Walsh': 'Documentary',
  'Michael Knowles': 'Commentary',
  'The Daily Wire': 'Podcast',
  'Daily Wire News': 'Documentary',
};

const normalizePortfolioTag = (tag: string): string => tagAliases[tag] || tag;

const sortPortfolioTags = (tags: string[]): string[] =>
  [...tags].sort((a, b) => {
    const aIndex = portfolioTagOrder.indexOf(a);
    const bIndex = portfolioTagOrder.indexOf(b);

    if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
    if (aIndex !== -1) return -1;
    if (bIndex !== -1) return 1;
    return a.localeCompare(b);
  });

export const getPortfolioVideos = async (): Promise<PortfolioVideo[]> =>
  replaceCommentSectionPortfolioVideos(portfolioVideos).map(video => ({
    ...video,
    tag: normalizePortfolioTag(video.tag),
  }));

export const getUniqueTags = async (): Promise<string[]> => {
  const videos = await getPortfolioVideos();
  const tags = videos.map(item => item.tag);
  return sortPortfolioTags([...new Set(tags)]);
};
